import { trackEvent, ACTIONS } from 'common/analytics';
import { track } from 'src/tracking/trackingService';

export class ClientImportAnalytics {
  public static CATEGORY = 'clients-import-flow';

  public static trackFailureHelpCenterClicked() {
    trackEvent(ClientImportAnalytics.CATEGORY, ACTIONS.CLICK, 'help-center-link');
  }

  public static trackFailureLiveChatClicked() {
    trackEvent(ClientImportAnalytics.CATEGORY, ACTIONS.CLICK, 'live-chat');
  }

  public static trackContinueToCampaignPromptClicked() {
    track('marketing.management.email_campaign.import_continue.clicked');
  }

  public static trackLaunchCampaignClicked() {
    track('marketing.management.email_campaign.import_launch.clicked');
  }

  public static trackCloseCampaignPromptClicked() {
    trackEvent(ClientImportAnalytics.CATEGORY, ACTIONS.CLICK, 'close-campaign-prompt');
  }
}
